import { IRoutesDefined } from "@/api_framework/api_modals/Routers";

export const DAY_CLOSING_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  CLINIC_CLOSING: {
    id: "CLINIC_CLOSING",
    title: "Day Closing",
    icon: "HiOutlineHome",
    url: "/app/closing/day-closing",
    RBACDescription: "Day Closing  ",
    description: "Day Closing",
    isVirtual: false,
    path: "day-closing",
    children: {},
  },
};
export const ACCOUNTING_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  FINANCE_SUMMARY: {
    id: "FINANCE_SUMMARY",
    title: "Financial Summary",
    icon: "HiOutlineHome",
    url: "/app/accounting/finance-summary",
    RBACDescription: "Manage Finance  ",
    description: "Manage Finacne ",
    isVirtual: false,
    path: "finance-summary",
    children: {},
  },
  DAILY_REVENUE_PAYMENTS: {
    id: "DAILY_REVENUE_PAYMENTS",
    title: "Daily Revenue & Payments",
    icon: "HiOutlineHome",
    url: "/app/accounting/daily-revenue-payments",
    RBACDescription: "Manage Daily Revenue and Payments",
    description: "Manage Daily Revenue and Payments",
    isVirtual: false,
    path: "daily-revenue-payments",
    children: {},
  },
  FINANCE_SKU_APPROVAL: {
    id: "FINANCE_SKU_APPROVAL",
    title: "Financial Variant Approval",
    icon: "HiOutlineHome",
    url: "/app/accounting/finance-sku-approval",
    RBACDescription: "Manage Finance SKU approval",
    description: "Manage Finance SKU approval",
    isVirtual: false,
    path: "finance-sku-approval",
    children: {},
  },
  REFUND_REQUEST: {
    id: "REFUND_REQUEST",
    title: "Refund Requests",
    icon: "HiOutlineHome",
    url: "/app/accounting/refund-request",
    RBACDescription: "Manage Refund Request ",
    description: "Manage Refund Request",
    isVirtual: false,
    path: "refund-request",
    children: {},
  },
  DEBIT_NOTE_REQUEST: {
    id: "DEBIT_NOTE_REQUEST",
    title: "Debit Note Requests",
    icon: "HiOutlineHome",
    url: "/app/accounting/debit-note-request",
    RBACDescription: "Manage Debit Request ",
    description: "Manage Debit Request",
    isVirtual: false,
    path: "debit-note-request",
    children: {},
  },
  REFUND_REQUEST_ACTION_CTA: {
    id: "REFUND_REQUEST_ACTION_CTA",
    title: "patient_waiting_list",
    icon: "PiUserListLight",
    path: "refund-request",
    RBACDisplayName: "REFUND_REQUEST_ACTION_BUTTON_CTA",
    RBACDescription: "Access to action button CTA in Refund Request.",
    isVirtual: true,
    url: "/app/accounting/refund-request/cta-action",
    children: {},
  },
  DEBIT_NOTE_REQUEST_ACTION_CTA: {
    id: "DEBIT_NOTE_REQUEST_ACTION_CTA",
    title: "patient_waiting_list",
    icon: "PiUserListLight",
    path: "debit-note-request",
    RBACDisplayName: "DEBIT_NOTE_REQUEST_ACTION_BUTTON_CTA",
    RBACDescription: "Access to action button CTA in debit note ",
    isVirtual: true,
    url: "/app/accounting/debit-note-request/cta-action",
    children: {},
  },
  UPDATE_PAYMENT_DETAILS: {
    id: "UPDATE_PAYMENT_DETAILS",
    title: "Update Payment Details",
    path: "payment-details",
    url: "/app/accounting/payment-details",
    description: "payment details",
    isVirtual: false,
    children: {},
  },
  CASH_CLOSING: {
    id: "CASH_CLOSING",
    title: "Cash Management",
    icon: "HiOutlineHome",
    url: "/app/accounting/cash-closing",
    RBACDescription: "Cash Closing  ",
    description: "Cash Closing",
    isVirtual: false,
    path: "cash-closing",
    children: {},
  },
  CASH_SORTES_ACTION: {
    children: {},
    icon: "BsDashCircleDotted",
    id: "CASH_SORTES_ACTION",
    path: "cash-closing-action",
    title: "available_slots",
    isVirtual: true,
    RBACDisplayName: "shortage amount approve action",
    RBACDescription: "shortage amount approve for clinic",
    url: "/app/accounting/cash-closing-action",
    description: "shortage amount approve",
  },
  FINANCE_PURCHASE_ORDER: {
    id: "FINANCE_PURCHASE_ORDER",
    title: "Finance Purchase Order",
    icon: "HiOutlineHome",
    url: "/app/accounting/finance-purchase-order",
    RBACDescription: "Finance PO",
    description: "Finacne PO",
    isVirtual: false,
    path: "finance-purchase-order",
    children: {},
  },
  FORCE_DISCOUNT: {
    id: "FORCE_DISCOUNT",
    title: "Force Discount",
    icon: "HiOutlineHome",
    url: "/app/accounting/force-discount",
    RBACDescription: "Bulk force discount on partially paid invoices",
    description: "Bulk force discount on partially paid invoices",
    isVirtual: false,
    path: "force-discount",
    children: {},
  },
  BAD_DEBT: {
    id: "BAD_DEBT",
    title: "Bad Debt",
    icon: "HiOutlineHome",
    url: "/app/accounting/bad-debt",
    RBACDescription: "Bulk bad debt knock-off of unpaid invoices",
    description: "Bulk bad debt knock-off of unpaid invoices",
    isVirtual: false,
    path: "bad-debt",
    children: {},
  },

  FORCE_DISCOUNT_UPLOAD_ACTION: {
    id: "FORCE_DISCOUNT_UPLOAD_ACTION",
    title: "force discount upload",
    path: "upload-cta",
    RBACDisplayName: "FORCE_DISCOUNT_UPLOAD_ACTION",
    RBACDescription: "Upload and apply Force Discount (Finance).",
    url: "/app/accounting/force-discount/upload-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  BAD_DEBT_UPLOAD_ACTION: {
    id: "BAD_DEBT_UPLOAD_ACTION",
    title: "bad debt upload",
    path: "upload-cta",
    RBACDisplayName: "BAD_DEBT_UPLOAD_ACTION",
    RBACDescription: "Upload and run Bad Debt (Finance).",
    url: "/app/accounting/bad-debt/upload-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  ACCOUNTING_CASH_CLOSING_CENTRAL_VIEW: {
    id: "ACCOUNTING_CASH_CLOSING_CENTRAL_VIEW",
    title: "cash closing central view",
    path: "cta",
    RBACDisplayName: "ACCOUNTING_CASH_CLOSING_CENTRAL_VIEW",
    RBACDescription: "Access the central (multi-clinic) Cash Closing view.",
    url: "/app/accounting/cash-closing/central-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
};
